module.exports = __webpack_public_path__ + "img/did_you_know.8fceee2b.png";